<template>
  <div class="mobile-bottom-nav" v-if="displayLeftDrawer">
    <!-- Tab Navigation -->
    <div class="tab-navigation">
      <v-tabs
        v-model="activeTab"
        bg-color="white"
        fixed-tabs
        color="#AB0520"
        slider-color="#AB0520"
        class="elevation-4"
      >
        <v-tab value="tab1" class="text-caption font-weight-bold" :ripple="false">Building & Room</v-tab>
        <v-tab value="tab3" class="text-caption font-weight-bold" :ripple="false">Room Details</v-tab>
        <v-tab value="tab2" class="text-caption font-weight-bold" :ripple="false">Equipment</v-tab>
      </v-tabs>
    </div>
    
    <!-- Tab Content -->
    <div class="tab-content">
      <v-window v-model="activeTab">
        <v-window-item value="tab1"><SrchClassrooms></SrchClassrooms></v-window-item>
        <v-window-item value="tab2"><SrchEquipment></SrchEquipment></v-window-item>
        <v-window-item value="tab3"><SrchClassification></SrchClassification></v-window-item>
      </v-window>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import SrchClassrooms from "./SrchClassrooms.vue";
import SrchEquipment from "./SrchEquipment.vue";
import SrchClassification from "./SrchClassification.vue";

export default {
  data: () => ({
    activeTab: 'tab1',
    displayLeftDrawer: true
  }),

  watch: {
    activeTab: function(val){
      console.log("Active tab value Mobile:", val)
      this.SET_ACTIVE_TAB(val);
      if(val == 'tab3'){
       
        // clears tab1
        if(this.getSelectedEquip) this.selectEquipAction(null)
        // this.populateCapacityAction(null)
        if(this.getSelectIntBldg) {
           this.SET_INT_BLDG(null)
           this.SET_INT_RM(null)
           this.clearAllBuildings()
          }

        this.SET_LYR_EFFECT('')
        // clear the selected rooms
        console.log("Clear selected building...!")
        // this.clearBuildings()
        // this.clearAllBuildings()

        
      } 
      else if(val == 'tab2'){
        this.SET_LYR_EFFECT('')
        // clear the selected rooms
        console.log("Clear selected building...!")
        // this.clearBuildings()
        this.clearAllBuildings()
        
        if(this.getSelectedClassification) {
          this.SET_SELECT_CLASSIFICATION(null)
        }
        if(this.getSelectedCapacity) this.SET_SELECT_CAPACITY(null)

      } 
      else if(val == 'tab1') {
        this.SET_LYR_EFFECT('1')
        
        
        // clears equip tab ... // clear the selected equipment
        if(this.getSelectedEquip) {
          console.log("Clear selected equipment...!")
          this.selectEquipAction(null) 
        }

        // this.SET_SELECT_CAPACITY(null)
        // this.SET_SELECT_CLASSIFICATION(null)
     
        // this.populateCapacityAction(null)
        if(this.getSelectIntBldg) {
           this.SET_INT_BLDG(null)
           this.SET_INT_RM(null)
          }
        if(this.getSelectedClassification) {
          this.SET_SELECT_CLASSIFICATION(null)
        }
        if(this.getSelectedCapacity) {
          this.SET_SELECT_CAPACITY(null)
        }
        this.clearAllBuildings()
      } 
    }
  },
  computed: {

    ...mapState({
      stateActiveTab: "activeTab",
      
    }),
    ...mapGetters(["getActiveTab","getLeftDr","getSelectIntBldg","getSelectedCapacity","getSelectedClassification","getSelectedEquip","getBtmShtRmsHt"]),
   
  },

  components: {
    SrchClassrooms, 
    SrchEquipment,     
    SrchClassification
  },

  methods: {
    ...mapMutations(["SET_ACTIVE_TAB","SET_LEFT_DR","SET_INT_BLDG","SET_INT_RM","SET_LYR_EFFECT","SET_SELECT_CAPACITY","SET_SELECT_CLASSIFICATION"]),
    ...mapActions(['clearBuildings','selectEquipAction','clearAllBuildings']),
  },
};
</script>
<style scoped>
.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
}

.tab-navigation {
  flex-shrink: 0;
  border-top: 1px solid #e0e0e0;
}

.tab-content {
  flex: 1;
  overflow-y: auto;
  max-height: calc(60vh - 48px);
  background: white;
}

>>>.v-list-item {
  padding: 0 !important;
}

>>>.v-window-item {
  padding: 8px;
}

>>>.v-btn:hover > .v-btn__overlay {
  background-color: transparent;
}

/* Prevent text selection on tabs */
>>>.v-tab {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
</style>